export default "/_next/static/images/img2-541d5b849e24d194526969d82123cefb.png";